<template>
  <div class="mention-list" :class="{ 'is-empty': items.length === 0 }">
    <template v-if="items.length">
      <button
        class="mention-list__item"
        v-for="(item, index) in items"
        :key="item.id"
        :class="{ 'is-selected': index === selectedIndex }"
        @click="selectItem(index)"
      >
        {{ item.label }}
      </button>
    </template>
    <div v-else class="mention-list__empty">
      No results
    </div>
  </div>
</template>

<script>
export default {
  name: 'MentionList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    command: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedIndex: 0,
    };
  },
  watch: {
    items() {
      this.selectedIndex = 0;
    },
  },
  methods: {
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        this.downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        this.enterHandler();
        return true;
      }

      return false;
    },
    upHandler() {
      this.selectedIndex = ((this.selectedIndex + this.items.length) - 1) % this.items.length;
    },
    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
    },
    enterHandler() {
      this.selectItem(this.selectedIndex);
    },
    selectItem(index) {
      const item = this.items[index];
      if (item) {
        this.command({ id: item.id, label: item.label });
      }
    },
  },
};
</script>

<style scoped>
.mention-list {
  padding: 0.2rem;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 10px 20px rgba(0, 0, 0, 0.1);
  max-height: 20rem;
  overflow-y: auto;
}

.mention-list__item {
  display: block;
  width: 100%;
  padding: 0.4rem 0.8rem;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
}

.mention-list__item:hover,
.mention-list__item.is-selected {
  background: #edf2f7;
  border-radius: 0.3rem;
}

.mention-list__empty {
  padding: 0.4rem 0.8rem;
  color: #a0aec0;
}

.mention-list.is-empty {
  display: none;
}
</style>
